import React, {Component} from 'react';
import styles from '../css-modules/mobile_gallery_sections.module.css';
import mobileStyles from '../css-modules/mobileStyles.module.css';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

class MobileGalleryBrSection extends Component {
  render () {
    return (
      <div className={styles.mobile_gallery_sections_container}>
        {this.props.sections && this.props.sections.length > 0 && this.props.sections.map((section, index) => (
          <div key={section.title} className={styles.mobile_gallery_section}>
            <Link to={section.linkTo} className={styles.mobile_gallery_section_link_div}>

              <div className={styles.mobile_gallery_section_image_container}>
                <img src={section.image} className={classNames(mobileStyles.shadowImage, styles.gallery_section_image)}/>
              </div>
              <p className={styles.section_title}>{section.title}</p>
            </Link>

          </div>
        ))}
      </div>
    )
  }
}

export default MobileGalleryBrSection;
